import { API } from '@/api/index';
export default {
    name: "ResearchID",
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    created() {

        this.$nextTick(function () {
            this.GetResearchAndInsightByID()
            this.GetResearchAndInsightPage()
        });
    },
    mounted() {
        this.$nextTick(function () {
            this.Scroll()
            this.Content_textH = $(this.$refs.Content_text).height()
        })
    },
    data() {
        return {
            ResearchIDData: {},
            ResearchData: [],
            ResearchPageData: [],
            Content_textH: 0,
            DisclaimerA: false,
            modalText: '',
            liveToastText: ``,
            BlankUrl: encodeURIComponent(`${window.location.href.replace("localhost:3000", "54.255.225.0")}`),
            Lang: localStorage.getItem('Language') == 1 ? process.env.VUE_APP_LANGUAGE1 : process.env.VUE_APP_LANGUAGE2
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        async GetResearchAndInsightByID() {
            try {
                const result = await API.get('GetResearchAndInsightByID', { id: this.id, lang: localStorage.getItem('Language') || '1' });
                this.ResearchIDData = result.data


            } catch (error) {
                this.ResearchIDData = []
            } finally {
                $('.Insightbannerimage').css({
                    'background-image': `url(${this.ResearchIDData.MastheadBasic_Article_Card_Thumbnail_Image || require('../../../assets/images/cgsiplaceholderimg.jpg')})`
                })
                document.title = `${this.ResearchIDData.SEO_Browser_Title_Tag} | ${process.env.VUE_APP_TITLE}`
                document.querySelector('meta[name="description"]').setAttribute('content', this.ResearchIDData.SEO_Meta_Description);
                this.GetResearchAndInsight(this.ResearchIDData)
            }
        },
        async GetResearchAndInsight(data) {
            const ResearchString = {
                sort: 'Date',
                order: 'desc',
                series: '',
                topic: data.Taggings.join(':'),
                format: '',
                country: '',
                year: '',
                url: '',
                lang: localStorage.getItem('Language') || '1'
            };
            try {
                const result = await API.get('GetResearchAndInsight', ResearchString);
                $.each(result.article, (i, c) => {
                    if (c.SEO_Page_Name != data.SEO_Page_Name) {
                        this.ResearchData.push(c)
                    }
                })
            } catch (error) {
                this.ResearchData = []
            } finally {

            }
        },
        async GetResearchAndInsightPage() {
            try {
                const result = await API.get('GetResearchAndInsightPage', { lang: localStorage.getItem('Language') || '1' });
                this.ResearchPageData = result.data
            } catch (error) {
                this.ResearchPageData = []
            } finally {

            }
        },
        PageChange: function (box) {
            console.log('GTM 32', `'event': 'load_more_click'`, `'section_title':insight`);
            gtag('event', 'load_more_click', {
                'section_title': 'insight',
            });
        },
        LearnMoregtm: function (name, url) {
            console.log('GTM 34', `'event': 'newsletter_subscribe'`, `'link_text':${name}`, `link_url': ${url}`, `cta_source: banner`);
            gtag('event', 'newsletter_subscribe', {
                'link_text': name,
                'link_url': url,
                'cta_source': 'banner'
            });
        },
        Copy: function () {
            navigator.clipboard.writeText(window.location.href).then(() => {
                this.liveToastText = this.$t('Liic')
                $('#liveToast').toast('show')
            }).catch(function (error) {

                this.liveToastText = `Failed to copy the URL: ${error}`
                $('#liveToast').toast('show')
            });
        },
        Print: function () {
            window.print();
        },
        disclaimerA: function () {
            this.DisclaimerA = !this.DisclaimerA
        },
        ContentList: function (BOX) {
            $('body').removeClass('sidebarshow');
            // Smooth scroll to anchor
            jQuery('html, body').animate({
                scrollTop: $(BOX).offset().top - 150
            }, 200);
        },
        Scroll: function () {
            $(window).on('scroll', function () {
                let scrollDistance = $(window).scrollTop() + 200;
                $('.anchorswpr .item').each(function (i) {
                    if ($(this).offset().top <= scrollDistance) {
                        $('.contentlist li.active').removeClass('active');
                        $('.mobilecontent li.active').removeClass('active');
                        $('.contentlist li').eq(i).addClass('active');
                        $('.mobilecontent li').eq(i).addClass('active');
                    }
                });
            });
        }
    },
    components: {

    }
};